module.exports = __webpack_public_path__ + "img/about-bg.13ae9bf8.png";